// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridContainer: {
      padding: theme.spacing(2),
    },
    searchFormControl: {},
    dialog: {
      minWidth: 500,
    },
    buttons: {
      justifyContent: 'flex-end',
      padding: 20,
    },
    itemText: {
      textTransform: 'uppercase',
    },
    searchingBy: {
      fontSize: theme.spacing(2),
      color: 'rgba(0, 0, 0, 0.54)',
    },
    chipContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      paddingTop: 5,
    },
    chip: {
      margin: theme.spacing(0.5),
      marginLeft: 0,
      marginBottom: 5,
      fontSize: 14,
      fontWeight: 550,
    },
    message: {
      marginTop: theme.spacing(1),
      color: theme.palette.colors.blue,
    },
    hideDeleteIcon: {
      display: 'none',
    },
    flex: {
      display: 'flex',
      alignItems: 'center',
    },
    minWidth: {
      minWidth: 220,
    },
    input: {
      background: '#F5F8FA',
      borderRadius: 20,
      maxHeight: 35,
      height: '100%',
      '& div': {
        maxHeight: 35,
        '& fieldset': {
          border: 'none',
        },
      },
    },
    darkStyle: {
      background: '#F5F8FA',
      borderRadius: 20,
      maxHeight: 35,
      height: '100%',
      marginLeft: -8,
      '& div': {
        maxHeight: 35,
        '& fieldset': {
          border: 'none',
        },
        '&:focus-within': {
          '& fieldset': {
            border: 'solid 1px #249eb2',
            borderRadius: 20,
          },
        },
      },
    },
  }),
);

export default useStyles;
